module.exports = __webpack_public_path__ + "74700febf0e4315c9835964272f67248.svg";